import React from "react";
import { Link } from "gatsby";
import shape1 from "../../assets/images/shape/shape1.svg";
import shape2 from "../../assets/images/shape/shape2.png";
import shape3 from "../../assets/images/shape/shape3.png";

/**
 *
 * @typedef {{text: string, url: string}} Breadcrum
 * @param {object} props
 * @param {string | React.ReactNode} props.pageTitle
 * @param {string} props.pageImage
 * @param {Breadcrum[]} props.breadcrumbs
 * @param {string} props.activePageText
 * @returns
 */
const PageBanner = props => {
  const { pageTitle, homePageUrl, homePageText, activePageText, breadcrumbs = [], pageImage } = props;

  if (homePageText) {
    breadcrumbs.unshift({ text: homePageText, url: homePageUrl || "/" });
  }
  const hasBreadcrumbs = breadcrumbs.length > 0;

  return (
    <div className="page-title-area">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-8 col-md-12">
            <div className="page-title-content">
              {pageTitle && <h2>{pageTitle}</h2>}
              {hasBreadcrumbs && (
                <ul>
                  {breadcrumbs.map((breadcrum, idx) => (
                    <li key={idx}>
                      <Link to={breadcrum.url}>{breadcrum.text}</Link>
                    </li>
                  ))}
                  <li>{activePageText}</li>
                </ul>
              )}
            </div>
          </div>

          {pageImage && (
            <div className="col-lg-4 col-md-12">
              <div className="image">
                <img src={pageImage} alt="banner" />
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="shape-img1">
        <img src={shape1} alt="人力资源软件" />
      </div>
      <div className="shape-img2">
        <img src={shape2} alt="人力资源系统" />
      </div>
      <div className="shape-img3">
        <img src={shape3} alt="绩效考核软件" />
      </div>
    </div>
  );
};

export default PageBanner;
